import { render, staticRenderFns } from "./compalanitModal.vue?vue&type=template&id=61e38074&scoped=true&"
import script from "./compalanitModal.vue?vue&type=script&lang=js&"
export * from "./compalanitModal.vue?vue&type=script&lang=js&"
import style0 from "./compalanitModal.vue?vue&type=style&index=0&id=61e38074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e38074",
  null
  
)

export default component.exports